
import { Options } from "vue-class-component";
import { Field, Form } from "vee-validate";
import * as yup from "yup";
import { AuthApi } from "../../autogen";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ChangePassword from "../organisms/ChangePassword.vue";
import FormMixin from "../../helpers/mixins/form";
import ActionButton from "@/components/atoms/ActionButton.vue";
@Options({
  components: { Form, Field, FieldError, FormError, ChangePassword, ActionButton }
})
export default class ForgotPassword extends FormMixin {
  globalErrors: { message: string }[] = [];
  async onBeforeSubmit(values: { username: string }) {
    await this.onSubmit(async () => {
      await new AuthApi().forgotPassword({
        forgotPasswordRequest: { username: values.username }
      });
      this.$router.push({ name: "ResetPassword", params: { usernamea: values.username } });
    });
  }
  validationSchema!: yup.AnyObjectSchema;
  beforeCreate() {
    this.validationSchema = yup.object({
      username: yup.string().required(this.$t("input_required", { field: "ユーザーID" }))
    });
  }
}
